import React, {FC} from 'react';

import {connect} from 'react-redux';

import {Price} from 'components/price/price';
import {ApplicationStoreType} from 'desktop/store';
import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import {getOrderReviewItemById} from '../../store/selectors/orderReviewItems/orderReviewItems';

import s from './cartItemPrice.scss';

export type PropsType = {id: number; item?: CheckoutItemType};

/**
 * Cart Item Price for checkout page
 *
 * @constructor
 */
export const CartItemPrice: FC<PropsType> = ({item}) => {
    // TODO: BUG-15361
    // If user will log in on CHP_SR to account that has items in cart
    // checkout page will crash duo getQuote request will return items for not logged user...
    if (!item) return null;

    const isPriceWithoutDiscount = Boolean(item.totalPrice !== item.totalFinalPrice);
    return (
        <div className={s.costWrapper}>
            {isPriceWithoutDiscount && (
                <>
                    <span aria-label="Price without discount" className={s.priceWithoutDiscount}>
                        <Price>{item.totalPrice}</Price>
                    </span>{' '}
                </>
            )}
            <span aria-label="Total final price" className={s.price}>
                <Price>{item.totalFinalPrice}</Price>
            </span>
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @param {PropsType} props - component props
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType, {id}: {id: number}) => ({
    item: getOrderReviewItemById(id)(store),
});

export const CartItemPriceConnected = connect(mapStateToProps)(CartItemPrice);
